import { Pill, Stack, Text, useText } from "@sveabank/cc-common";
import Paper from "../../components/paper";
import type { ActiveEngagement } from "../../types/application";

type Props = { engagement: ActiveEngagement };

const IsCustomer = ({ engagement }: Props) => {
	const [t, texts] = useText();

	return (
		<Paper key={engagement.orgNr}>
			<Stack gap={2}>
				<Pill status="info" text={t(texts.dashboardPage.applications.statuses.isCustomer)} />
				<Text component="h4" className="text-text-primary text-xl" bold>
					{engagement.name}
				</Text>
			</Stack>
		</Paper>
	);
};

export default IsCustomer;
